export default __webpack_public_path__ + "static/image-8-8fab1bad07206cf67eb15999513193dc.jpg";